import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getQualificationsById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGetQualificationsRowData = (rowId) => {
  const { t } = useTranslation('common');

  return useQuery({
    enabled: !!rowId,
    queryKey: ['qualifications', 'get', rowId],
    queryFn: async () => {
      const { data } = await getQualificationsById(rowId);
      return data;
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('errorDuringFetching')
      });
    }
  });
};
export default useGetQualificationsRowData;
